var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgX = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.313 6.771L15.138 0h-1.38l-5.06 5.88L4.66 0H0l6.11 8.89L0 15.993h1.38l5.342-6.21 4.266 6.21h4.66l-6.336-9.22zM7.422 8.97l-.62-.885L1.878 1.04h2.12l3.975 5.686.619.885L13.758 15h-2.12L7.422 8.97z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgX);
export default ForwardRef;